import Product from "../../../../../../@types/Product";

const SeatFrames: Product[] = [
    {
        id: 1,
        name: 'Golf Kit 2 Passenger',
        sku: '28-389',
        price: 0.00,
        retailPrice: 0.00,
    },
];

export default SeatFrames;